<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="title" placeholder="标题"></el-input>
                        <el-select v-model="status" placeholder="状态">
                            <el-option label="草稿" value="DRAFT"> </el-option>
                            <el-option label="发布" value="RELEASE"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small"  @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>新增
                                </el-button>
                                <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handlePublish"><i
                                    class="el-icon-circle-plus-outline"></i>发布
                                </el-button>
                                <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handleDelete"><i
                                    class="el-icon-circle-plus-outline"></i>删除
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            @selection-change="handleSelectionChange"
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                type="selection"
                                header-align="center"
                                align="center"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                prop="title"
                                label="标题"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>

                            <el-table-column
                                prop="sort"
                                label="排序"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                label="状态" width="100">
                            </el-table-column>

                            <el-table-column
                                prop="createTime"
                                align="center"
                                header-align="center"
                                width="160"
                                label="创建时间">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                width="150"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            :title="titleDialog"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="900px">
            <div class="dialogContent" v-loading="loading">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input-number v-model="form.sort" placeholder="请输入排序"></el-input-number>
                    </el-form-item>
                    <!--<el-form-item label="缩略图片" prop="modelBanner">
                        <div style="display: flex;">
                            <uploadImage
                                :buttonName="'缩略图片'"
                                :img-file="thumbnailUrl"
                                :width="'372'"
                                :height="'126'"
                                :imgsBtn="imgsBannerBtn"
                                @avatarChange="avatarChange($event,'ban')"
                                @getDragImgFile="getDragImgFile($event,'ban')"
                                @deleteImg="deleteImg($event,'ban')"
                            ></uploadImage>
                        </div>
                        <span style="color:#DCDFE6" >图片规格，372px * 126px</span>
                    </el-form-item>-->
                    <el-form-item label="图片" prop="imgList">
                        <div style="display: flex;">
                            <uploadImage
                                :buttonName="'上传图片'"
                                :img-file="form.caseBannerList"
                                :width="'372'"
                                :height="'126'"
                                :imgsBtn="imgsBtn"
                                @avatarChange="avatarChange($event,'img')"
                                @getDragImgFile="getDragImgFile($event,'img')"
                                @deleteImg="deleteImg($event,'img')"
                            ></uploadImage>
                        </div>
                        <span style="color:#DCDFE6" >图片规格，372px * 126px</span>
                    </el-form-item>
                    <el-form-item label="内容" prop="modelDes">
                        <editor  v-model='form.content'  :init='editorInit'></editor>
                    </el-form-item>

                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        appletCaseQuery,
        caseCancel,
        publish,
        caseSave,
        uploadPicture,
        uploadFile,
        caseUpdate,
        caseGet
    } from '../../utils/interface';
    import tinymce from '@/components/tinymce'
    import 'tinymce/plugins/image'
    import 'tinymce/plugins/table'
    import uploadImage from '@/components/uploadImage'
    export default {
        components: {
            uploadImage,
            tinymce,
        },
        data() {
            return {
                title:'',
                titleDialog:'',
                status: '',
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0,
                type: 'ABOUT',
                multipleSelection:[],
                thumbnailUrl:[],
                form:{uuid:'',title:'',sort:99,thumbnailUrl:'',caseBannerList:[],content:'',type: 'ABOUT',},
                rules:{
                    title: [
                        {required: true, message: '请输入标题', trigger: 'blur'}
                    ],
                    sort: [
                        {required: true, message: '请输入排序',trigger: 'blur'}
                    ],
                },
                imgsBtn: true,
                imgsBannerBtn: true,
                loading:false,
                uuid:'',
                dialogVisible:false,
                editorInit: {//编辑框的配置项目
                    selector: '#editor',
                    /* 语言配置，将其转化为中文，如果main.js配置不起作用，也可在这里配置 */
                    language_url: '/static/tinymce/langs/zh_CN.js',
                    language: 'zh_CN',
                    // images_upload_url: '/service-center/upload/file/single',
                    /* 引入的插件，与上面相对应 */
                    plugins: 'image table imagetools',
                    images_upload_handler: (blobInfo, success, failure) => {
                        var formData;
                        formData = new FormData();
                        formData.append('file',blobInfo.blob(), blobInfo.filename());

                        // 上传接口
                        uploadFile(formData).then((res)=>{
                            success(res.url);
                        })
                    },
                    /* 菜单栏配置 */
                    // menubar: 'file edit insert view format table',//菜单栏显示的项目标题
                    menubar: false,//隐藏菜单栏
                    // menu: {//菜单栏项目点击后下拉的内容，items为下拉内容
                    //   file: {title: 'File', items: 'newdocument'},
                    //   edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
                    //   insert: {title: 'Insert', items: 'link media | template hr'},
                    //   view: {title: 'View', items: 'visualaid'},
                    //   format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
                    //   //items里的所有配置项所属为table插件，如果没引入table插件，菜单栏该项目不显示
                    //   table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
                    // },
                    font_formats: 'Arial=arial,helvetica,sans-serif; 宋体=SimSun;  微软雅黑=Microsoft Yahei; Impact=impact,chicago;', //字体
                    fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px', //文字大小

                    /* 工具栏配置 */
                    toolbar:'bold italic underline strikethrough  | fontselect | fontsizeselect | formatselect \
            | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist \
            | outdent indent blockquote | removeformat| undo redo | link unlink image media pageembed \
            insertdatetime table  hr pagebreak codesample | code fullscreen preview', //工具条
                    /* 其它配置 */
                    branding: false, //水印
                    elementpath: false, //底部元素路径
                    paste_data_images: true, //允许粘贴图片
                    height: 300,//编辑框高度
                    statusbar: false, // 隐藏编辑器底部的状态栏
                    toolbar_mode: 'wrap'

                }
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
        },
        methods: {
            getList(){
                let params = {
                    type: this.type,
                    title:this.title,
                    status:this.status,
                    current:this.current,
                    pageSize:this.pageSize,
                    multipleSelection: [],
                }
                appletCaseQuery(params).then((res)=>{
                    this.tableData = res.data;
                    this.total = res.total;
                });
            },
            resetData(){
                this.title = '';
                this.status = '';
                this.current = 1;
                this.getList();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },
            init(){
                this.title = '';
                this.status = '';
                this.current = 1;
                this.getList()
            },
            handleDelete(){
                let uuidArr=[];
                this.multipleSelection.map((item) => {
                    uuidArr.push(item.uuid);
                });
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    caseCancel(uuidArr).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
            handlePublish(){
                let uuidArr=[];
                this.multipleSelection.map((item) => {
                    uuidArr.push(item.uuid);
                });
                this.$confirm('确定要发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    publish(uuidArr).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '发布成功!'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 编辑/新增
            toDialog(type,id){
                this.dialogVisible = true
                this.uuid = id;
                if (type === 'add') {
                    this.titleDialog = '新增'
                    this.uuid = ''
                    this.reset()
                    this.imgsBtn = true;
                    this.imgsBannerBtn = true;
                } else {
                    this.titleDialog = '编辑'
                    this.uuid = id
                    this.getDetail(id)
                    if(this.form.thumbnailUrl){
                        this.imgsBannerBtn = false;
                    }else {
                        this.imgsBannerBtn = true;
                    }
                }
            },
            getDetail(uuid){
                this.thumbnailUrl=[];
                caseGet(uuid).then((item)=>{
                    this.form = item;
                    if(this.form.thumbnailUrl){
                        this.thumbnailUrl.push({url:this.form.thumbnailUrl});
                    }
                    let caseBannerList =[];
                    if(this.form.caseBannerList.length>0){
                        this.form.caseBannerList.forEach((item)=>{
                            caseBannerList.push({url:item.bannerPath});
                        })
                        this.form.caseBannerList = caseBannerList;
                    }
                })
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.thumbnailUrl.length>0){
                            this.form.thumbnailUrl = this.thumbnailUrl[0].url;
                        }
                        let caseBannerList =[];
                        if(this.form.caseBannerList.length>0){
                            this.form.caseBannerList.forEach((item)=>{
                                caseBannerList.push({bannerPath:item.url});
                            })
                            this.form.caseBannerList = caseBannerList;
                        }

                        this.loading = true
                        this.form.uuid=this.uuid;
                        caseSave(this.form).then((res)=>{
                            this.$message.success('保存成功！')
                            this.loading = false
                            this.dialogVisible = false
                            this.getList();
                        })
                    } else {
                        return false;
                    }
                });
            },
            reset() {
                this.thumbnailUrl=[];
                this.form = {
                    uuid:'',title:'',sort:99,thumbnailUrl:'',caseBannerList:[],content:'',type: 'ABOUT',
                }
                this.$nextTick(()=>{
                    if(this.$refs.ruleForm){
                        this.$refs.ruleForm.clearValidate()
                    }
                })
            },
            // 上传成功
            avatarChange(val,type) {
                if(type == 'ban'){
                    this.thumbnailUrl = val
                    this.bannerImageListLength(val)
                }else if (type == 'img'){
                    this.form.caseBannerList = val
                }
            },
            // 删除图片
            deleteImg(val,type) {
                if(type == 'ban'){
                    this.thumbnailUrl = val
                    this.bannerImageListLength(val)
                }else if (type == 'img'){
                    console.log(val)
                    this.form.caseBannerList = val
                }
            },
            // 获取拖拽后的图片
            getDragImgFile(file,type) {
                if(type == 'ban'){
                    this.thumbnailUrl = file
                    this.bannerImageListLength(file)
                }else if(type == 'img'){
                    if (file) {
                        this.form.caseBannerList = file
                    }
                }
            },
            // 当前封面图片的个数
            bannerImageListLength(val){
                if (val.length > 0 ) {
                    this.imgsBannerBtn = false
                }else {
                    this.imgsBannerBtn = true
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/applet/appletAboutList.vue